class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // An AJAX add already supplied current section HTML and opened the drawer.
    // Do not immediately replace it again on this first visibility pass;
    // that second render can swallow the customer's first quantity click.
    if (this.hasRenderedContents) {
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      return;
    }

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains('menu-closing')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.hasRenderedContents = true;
    this.productId = parsedState.id;

    // While the drawer is open (upsell adds, gift wrap, quick view),
    // patch the money-touched regions instead of swapping the whole
    // drawer — keeps open collapsibles, scroll and upsell state intact.
    // Main drawer only, and not while it is animating closed. The old
    // selector also matched any open nested panel (note, discount, gift).
    const mainDetails = this.drawer && this.drawer.querySelector('details');
    const drawerOpen = !!mainDetails &&
      mainDetails.hasAttribute('open') &&
      !mainDetails.classList.contains('menu-closing');

    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) return;

      if (
        section.id === 'mini-cart' &&
        drawerOpen &&
        window.theme && theme.patchMiniCart &&
        parsedState.sections[section.id] &&
        theme.patchMiniCart(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector))
      ) return;

      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

// A successful discount apply updates the cart in place. Once that update
// is confirmed, clear the typed code and close only the discount sheet.
// Removing an existing discount does not auto-close because its input is blank.
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event?.source !== 'cart-discount') return;

    const discount = document.querySelector('#mini-cart details[open] cart-discount');
    if (!discount) return;

    const input = discount.querySelector('input[name="discount"]');
    if (!(input instanceof HTMLInputElement) || input.value.trim() === '') return;

    input.value = '';
    const details = discount.closest('details');
    const summary = details?.querySelector('summary');
    if (!details || !(summary instanceof HTMLElement)) return;

    requestAnimationFrame(() => {
      if (details.hasAttribute('open')) summary.click();
    });
  });
}

// Gift details autosave. The gift boxes in the drawer and on the cart page
// save to the cart as the customer types, so the message reaches the order
// whichever checkout button she uses. Saved as cart attributes, which show
// on the order in Shopify admin under Additional details.
(function () {
  if (window.hmGiftAutosave) return;
  window.hmGiftAutosave = true;

  var FIELDS = /^attributes\[(gift-note|gift-wrapping-instructions)\]$/;
  var timers = {};

  function save(field) {
    var match = field.name && field.name.match(FIELDS);
    if (!match) return;
    var attributes = {};
    attributes[match[1]] = field.value;
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function (e) { console.error('[gift autosave]', e); });
  }

  function schedule(field, wait) {
    var match = field && field.name && field.name.match(FIELDS);
    if (!match) return;
    clearTimeout(timers[match[1]]);
    timers[match[1]] = setTimeout(function () { save(field); }, wait);
  }

  document.addEventListener('input', function (e) { schedule(e.target, 500); });
  document.addEventListener('change', function (e) { schedule(e.target, 0); });
})();
